// extracted by mini-css-extract-plugin
export var tableVGrid = "_26c209f00de044dce2a3026da81d6918-css";